<template>
    <div class="all">
      <my-title :msg="title"></my-title>
      <div class="Order">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="请输入订单号" style="width: 270px;display: inline-block">
            <el-input v-model="order_num" style="width:200px;" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="状态" style="width: 270px;display: inline-block">
            <el-select v-model="status" placeholder="请选择状态">
              <el-option label="未支付" value="1"></el-option>
            </el-select>
          </el-form-item>
        <!--  <div class="block" style="display: inline-block">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>-->
          <el-button type="primary" icon="el-icon-search" @click="init">查询</el-button>
        </el-form>
      </div>
      <div class="aviessHei">
        <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 10px">
          <el-col :span="3">
            <div class="grid-content">订单号</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content">收货人</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content">金额</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content">支付类型</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content">订单备注</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content">日期</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">操作</div>
          </el-col>
        </el-row>
        <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 2px" v-for="(item,key) in OrderList" :key="key">
          <el-col :span="3">
            <div class="grid-content">{{item.order_num}}</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content">{{item.peo_name?item.peo_name:'暂无'}}</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content">{{item.price}}</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content">{{item.pay_type==1?'货到付款':'在线支付'}}</div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content">{{item.content?item.content:'暂无'}}</div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content">{{item.add_time | filterDate('yyyy/MM/dd')}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <el-button type="primary" @click="getFind(item.id)">查看详情</el-button>
              <el-button type="danger">退货</el-button>
            </div>
          </el-col>
        </el-row>
        <el-dialog title="详细信息" :visible.sync="dialogFormVisible" >
          <el-form :model="findOr" id="printTest">
            <el-form-item label="订单号" :label-width="formLabelWidth">
              <el-input v-model="findOr.order_num" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="总金额" :label-width="formLabelWidth">
              <el-input v-model="findOr.price" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="省" :label-width="formLabelWidth">
              <el-input v-model="findOr.pro_name" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="市" :label-width="formLabelWidth">
              <el-input v-model="findOr.city_name" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="区" :label-width="formLabelWidth">
              <el-input v-model="findOr.area_name" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="详细地址" :label-width="formLabelWidth">
              <el-input v-model="findOr.add_ress" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 10px">
              <el-col :span="7">
                <div class="grid-content">商品名称</div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content">单价</div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content">总价</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">数量</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">颜色</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">颜色图片</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content">时间</div>
              </el-col>
            </el-row>
            <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 2px" v-for="(item,index) in findOr.goods" :key="index">
              <el-col :span="7">
                <div class="grid-content" style="line-height: 20px">{{item.goods_name}}</div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content">{{item.price}}</div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content">{{item.total_price}}</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">{{item.num}}</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">{{item.goods_color_name?item.goods_color_name:'暂无'}}</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">
                  <img :src="$store.state.Url+item.goods_color_img" alt="" style="display: inline-block;width: 30px;height: 30px;" v-if="item.goods_color_img">
                  <span v-else>暂无</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content">{{item.add_time | filterDate('yyyy/MM/dd')}}</div>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            <el-button type="primary" v-print="'#printTest'">打 印</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
</template>

<script>
  import {getOrList,getOrFind} from '../api/Mycen'
    export default {
        name: "Order",
        data(){
          return{
            title:'订单查询',
            input:'',
            value:'',
            value1:'',
            form:{
              name:''
            },
            OrderList:[],
            dialogTableVisible: false,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            findOr:{
              goods:[]
            },
            //筛选
            order_num:'',
            status:'',
            sta_time:'',
            end_time:'',
          }
        },
        mounted() {
          this.init()
        },
        methods:{
          parseTime(d) {
            var newDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' '
              + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
            return new Date(newDate).getTime();
          },
          init(){
     /*       this.sta_time = this.parseTime(this.value1[0])
            this.end_time = this.parseTime(this.value1[1])*/
            getOrList({
              order_num:this.order_num,
              status:this.status,
      /*        sta_time:this.sta_time,
              end_time:this.end_time,*/
            }).then(res=>{
              this.OrderList = res.result
            })
          },
          getFind(id){
            getOrFind({id:id}).then(res=>{
              this.findOr = res.result
              this.dialogFormVisible = true
            })
          },
          getDayin(){
            console.log('调用打印')
          }
        }
    }
</script>

<style scoped lang="less">
  @import "css/Order";
  .aviessHei{
    height: 720px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Order.vue